import { Notification } from '@pepsico-ds/ui'
import React, { useEffect } from 'react'
import { Box } from '@mui/material'

function NotificationCard({
  title,
  text,
  type,
  primaryActionLabel,
  primaryActionOnClick,
  secondaryActionLabel,
  secondaryActionOnClick,
  onClose,
}) {
  useEffect(() => {
    if (!primaryActionLabel && !secondaryActionLabel) {
      const timer = setTimeout(() => {
        onClose()
      }, 10000)

      return () => clearTimeout(timer)
    }

    return undefined
  }, [primaryActionLabel, secondaryActionLabel, onClose])

  return (
    <Box
      sx={{
        position: 'relative',
        margin: '7px 0',
        zIndex: '9',
      }}
    >
      <Notification
        title={title}
        text={text}
        type={type}
        primaryActionLabel={primaryActionLabel || undefined}
        primaryActionOnClick={primaryActionOnClick || undefined}
        secondaryActionLabel={secondaryActionLabel || undefined}
        secondaryActionOnClick={secondaryActionOnClick || undefined}
      />
    </Box>
  )
}

export default NotificationCard
